import React from 'react'
import PrimaryButton from '../buttons/PrimaryButton';
import '../../styles/cards/card.css';

const SingleSiteCard = ({siteName, province, district, sector, scannedBooks, scannedRecords, completionRate}) => {
  return (
    <>
        <div className="single-site-container">
            <div className="single-site">
                <div className="site-info">
                    <div className="name-and-data">
                    <div className="site-name">
                        Site: <span>{siteName}</span>
                    </div>
                    <div className="site-data">
                        <div className="site-data-item">
                            Province: <span>{province}</span>
                        </div>
                        <div className="site-data-item">
                            District: <span>{district}</span>
                        </div>
                        {sector && (
                            <div className="site-data-item">
                                Sector: <span>{sector}</span>
                            </div>
                        )}
                        <div className="site-data-item">
                            Scanned Books: <span>{scannedBooks}</span>
                        </div>
                        <div className="site-data-item">
                            Scanned Records: <span>{scannedRecords}</span>
                        </div>
                    </div>

                    </div>
                
                </div>

                <div className="percentage">
                    <div>{completionRate}%</div>
                </div>
            </div>
        </div>
    </>
  )
}

export default SingleSiteCard